import {
    PrescriptionRenewalSurveyResultsArray,
    PrescriptionRenewalSurveyResultsType,
} from './types'
import PrescriptionRenewalSurveyResultsView from './PrescriptionRenewalSurveyResultsView'
import React from 'react'
import {TFunction} from 'i18next'
import {useTranslation} from 'react-i18next'

export const dataKeysOrder = [
    'prescriptionsToBeRenewed',
    'medicationUsePurpose',
    'hasExperiencedMedicationEffective',
    'medicationEffectivenessAdditionalInformation',
    'hasExperiencedSideEffectsFromMedication',
    'sideEffectsAdditionalInformation',
    'hasExperiencedPreviousDosageSuitable',
    'previousDosageSuitabilityAdditionalInformation',
    'hasExperiencedConditionInBalance',
    'conditionInBalanceAdditionalInformation',
    'additionalInformation',
    'lastPharmacotherapyFollowUp',
]

export const getTranslation = (t: TFunction): {[key: string]: string} => ({
    additionalInformation: t(
        'Any additional information for the doctor regarding prescription renewal and medication review ' +
        '(e.g. pregnancy, possible drug allergies, use of supplements, blood pressure levels for blood ' +
        'pressure-affecting medications)',
    ),
    conditionInBalanceAdditionalInformation: t('Please elaborate'),
    hasExperiencedConditionInBalance: t('Do you feel the condition being treated is currently in good and sufficient balance with your current medication'),
    hasExperiencedMedicationEffective: t('Has the medication been beneficial'),
    hasExperiencedPreviousDosageSuitable: t('Do you still consider the previous dosage instructions suitable'),
    hasExperiencedSideEffectsFromMedication: t('Have you noticed side effects or other problems during the treatment'),
    lastPharmacotherapyFollowUp: t('When was your medication therapy last monitored at an appointment or through tests (e.g. blood tests)'),
    medicationEffectivenessAdditionalInformation: t('Please elaborate'),
    medicationUsePurpose: t('What illness, symptom, or condition are you using this medication for'),
    prescriptionsToBeRenewed: t('Which medication prescription would you like to renew (medication, purpose of use, strength, and dose you are using)'),
    previousDosageSuitabilityAdditionalInformation: t('Please elaborate'),
    sideEffectsAdditionalInformation: t('Please elaborate'),
})

const PrescriptionRenewalSurveyResults = ({data}: { data: PrescriptionRenewalSurveyResultsType }): React.ReactElement => {
    const {t} = useTranslation()

    const dataArray = React.useMemo(() => {
        const translations = getTranslation(t)
        return Object.entries(data)
            .sort((a, b) => dataKeysOrder.indexOf(a[0]) - dataKeysOrder.indexOf(b[0]))
            .map(([key, value]): PrescriptionRenewalSurveyResultsArray => [key, value, translations[key] ?? key])
    }, [data, t])

    return <PrescriptionRenewalSurveyResultsView data={dataArray} />
}

export default PrescriptionRenewalSurveyResults
